<!--
  AssignmentStudentsModal — 지정별 수강생 등록 상태 (GET /voucher/org/{org}/class-vouchers/{idx}/students)
  · 상태: REGISTERED / PROCESSING / AVAILABLE / OWNED / OTHER_VOUCHER / LIMIT_REACHED / CLOSED, late_joiner(지정 후 합류)
-->
<template>
  <a-modal :open="true" :title="`수강생 등록 현황 — ${assignment.title}`" :sub="subText" size="lg" @close="$emit('close')">
    <div v-if="loading" class="p-loader"><div class="p-spinner" /></div>
    <div v-else-if="error" class="p-alert p-alert--err"><div class="p-alert__body">{{ error }}</div></div>
    <template v-else-if="data">
      <div class="p-chips p-mb-12">
        <a-pill v-for="(n, k) in data.counts" :key="k" :kind="studentStatusKind(k)">{{ studentStatusLabel(k) }} {{ n }}</a-pill>
      </div>
      <a-empty v-if="!data.students || !data.students.length" title="수강생이 없습니다" />
      <a-table v-else :columns="cols" :rows="data.students" row-key="users_idx" dense>
        <template #cell-name="{ row }">
          <div class="p-cell-class">
            <div class="p-avatar">{{ (row.name || '?').charAt(0) }}</div>
            <div>
              <div class="p-cell-title">{{ row.name }}</div>
              <div class="p-cell-sub p-mono">{{ row.email }}</div>
            </div>
          </div>
        </template>
        <template #cell-enrollment_date="{ row }">
          <span class="p-mono">{{ fmtDateTime(row.enrollment_date) }}</span>
          <a-pill v-if="row.late_joiner" kind="warn" class="p-ml-6">지정 후 합류</a-pill>
        </template>
        <template #cell-status="{ value }"><a-pill :kind="studentStatusKind(value)">{{ studentStatusLabel(value) }}</a-pill></template>
        <template #cell-amount="{ row }">
          <span v-if="row.status === 'REGISTERED'" class="p-amount">{{ fmtAmount(row.amount, row.currency_code || currency) }}</span>
          <span v-else class="p-cell-sub">-</span>
        </template>
        <template #cell-registered_at="{ value }"><span class="p-mono">{{ fmtDateTime(value) }}</span></template>
      </a-table>
    </template>
    <template #foot>
      <a-btn kind="ghost" @click="load">새로고침</a-btn>
      <a-btn kind="primary" @click="$emit('close')">닫기</a-btn>
    </template>
  </a-modal>
</template>

<script>
import AModal from '@/components/Pineapple/AModal.vue';
import ATable from '@/components/Pineapple/ATable.vue';
import APill from '@/components/Pineapple/APill.vue';
import ABtn from '@/components/Pineapple/ABtn.vue';
import AEmpty from '@/components/Pineapple/AEmpty.vue';
import { fmtAmount, fmtDate, fmtDateTime, gradeLabel, studentStatusKind, studentStatusLabel, voucherErrorText } from '../orgUtils';

export default {
  name: 'AssignmentStudentsModal',
  components: { AModal, ATable, APill, ABtn, AEmpty },
  props: {
    orgIdx: { type: [Number, String], required: true },
    assignment: { type: Object, required: true },
    currency: { type: String, default: '' },
  },
  emits: ['close'],
  data() {
    return {
      data: null,
      loading: false,
      error: '',
      cols: [
        { key: 'name',            label: '학생' },
        { key: 'enrollment_date', label: '수강 합류', width: '230px' },
        { key: 'status',          label: '상태',     width: '140px' },
        { key: 'amount',          label: '차감액',   width: '110px', align: 'right' },
        { key: 'registered_at',   label: '등록일',   width: '190px' },
      ],
    };
  },
  computed: {
    assignmentIdx() { return this.assignment.idx != null ? this.assignment.idx : this.assignment.classroom_voucher_idx; },
    subText() {
      const cv = this.data && this.data.classroom_voucher;
      const cls = cv && cv.classroom_name ? `${cv.classroom_name} · ` : '';
      return `${cls}${gradeLabel(this.assignment.grade)} · 기한 ${fmtDate(this.assignment.register_until)}`;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    fmtAmount, fmtDateTime, studentStatusKind, studentStatusLabel,
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const res = await this.$axios({
          method: 'get',
          url: `/voucher/org/${this.orgIdx}/class-vouchers/${this.assignmentIdx}/students`,
          loadingBar: false,
        });
        this.data = res.data || null;
      } catch (e) {
        this.error = voucherErrorText(e, '수강생 상태를 불러오지 못했습니다.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_org.scss';

.p-mb-12 { margin-bottom: 12px; }
.p-ml-6 { margin-left: 6px; }
</style>
